import { Autocomplete as MuiAutocomplete, Chip, TextField } from "@mzc-pdc/ui";
import { IconCancelCircle, IconErrorCircle } from "@mzc-cloudplex/icons";
import EllipsisTooltip from "@components_v2/ellipsis-tooltip/ellipsis-tooltip";
import i18n from "@lib/i18n";

export const AutocompleteTagsNoStarticon = ({
    type,
    open,
    tags,
    value,
    disabled,
    inputDisabled,
    setValue,
    onDelete,
    onSubmit,
    error,
    isEdit,
    placeholder,
    helperText,
    popperComponent,
    noOptionsText,
    maxCount,
    matchTrimmed,
}) => {
    // 입력 중인 값과 같은 칩을 빨갛게 짚어준다.
    // matchTrimmed 면 앞뒤 공백을 무시해, 중복 검증(uniqueInTrimmed)과 같은 기준으로 비교한다.
    // 대소문자는 가린다 — 표시 기준을 검증 기준과 어긋나게 두면 "왜 이 칩이 빨간지" 를 설명할 수 없다.
    // 기본값(false)은 기존 원문 엄격 비교 — 내장 uniqueIn 검증과 기준이 같다.
    const isMatchedWithInput = (option) =>
        matchTrimmed ? String(option ?? "").trim() === String(value ?? "").trim() : option === value;

    return (
        <MuiAutocomplete
            clearText={i18n.t(`common::label::Clear`, `Clear`)}
            openText={i18n.t(`common::label::Open`, `Open`)}
            closeText={i18n.t(`common::label::Close`, `Close`)}
            freeSolo={true} //Note : freesolo를 사용시 옵션과는 상관없는 값을 사용할 수 있게 되서 noOptionsText를 사용불가능(옵션 사용하는 경우 false 사용해야함)
            multiple
            open={open}
            value={tags ? tags.map((tag) => tag.value) : []}
            options={[]}
            PopperComponent={popperComponent ?? null}
            disableCloseOnSelect={!!tags}
            disabled={disabled}
            getOptionLabel={(option) => {
                if (typeof option === "string") return option;
                else return option?.title;
            }}
            noOptionsText={noOptionsText} //Note : Chip 개선에 들어가는 검색 결과에 따른 옵션이 없을 경우 안내가 들어감
            renderTags={(v, getTagProps) => {
                return v.map((option, index) => (
                    <Chip
                        key={option}
                        {...getTagProps({ index })}
                        size={`small`}
                        label={
                            <EllipsisTooltip
                                text={option}
                                maxWidth={200}
                                variant="body3"
                                // 태그 값의 연속 공백이 접혀 보이면 값이 변형된 것처럼 읽힌다 — 원문 그대로 표시한다
                                typographyProps={{ sx: { whiteSpace: "pre" } }}
                            />
                        }
                        avatar={<></>}
                        color={
                            (value && isMatchedWithInput(option)) || (value && index === maxCount - 1)
                                ? "error"
                                : undefined
                        }
                        onDelete={() => onDelete(index)}
                        deleteIcon={<IconCancelCircle size={12} />}
                        sx={{
                            marginRight: "4px",
                        }}
                    />
                ));
            }}
            renderInput={(params) => {
                return (
                    <>
                        <TextField
                            {...params}
                            inputProps={{ ...params.inputProps, value: value, readOnly: inputDisabled }}
                            hiddenLabel
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: error ? <IconErrorCircle color={`error`} size={16} /> : undefined,
                            }}
                            error={error}
                            placeholder={tags?.length > 0 ? "" : placeholder}
                            helperText={helperText}
                            onChange={(e) => {
                                setValue(e.target.value);
                            }}
                            onKeyDown={(e) => {
                                if (tags?.length > 0 && e.code === "Backspace" && value === "") {
                                    onDelete(tags.length - 1);
                                }
                            }}
                            onKeyUp={(e) => {
                                if ((e.code === "Enter" || e.code === "NumpadEnter") && !error) {
                                    onSubmit();
                                }
                            }}
                            // isEdit={isEdit}
                        />
                    </>
                );
            }}
            // open={false} //option dropdown 비활성화
        />
    );
};
